import type { Theme, ThemeProviderProps as MuiThemeProviderProps } from '@mui/material/styles';
import type { ThemeOptions } from './types';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles';

import { useSettingsContext } from 'src/components/settings';

import { useTranslate } from '../locales';
import { createTheme } from './create-theme';

export type ThemeProviderProps = Partial<MuiThemeProviderProps<Theme>> & {
  themeOverrides?: ThemeOptions;
};

export function ThemeProvider({ themeOverrides, children, ...other }: ThemeProviderProps) {
  const settings = useSettingsContext();

  const { currentLang } = useTranslate();

  const theme = createTheme({
    settingsState: settings.state,
    themeOverrides,
    localeComponents: currentLang.systemValue,
  });

  return (
    <ThemeVarsProvider disableTransitionOnChange theme={theme} {...other}>
      <CssBaseline />
      {children}
    </ThemeVarsProvider>
  );
}
